<div class="drawer-wrapper" *ngIf="open" [class.open]="open">

    <!-- BACKDROP -->
    <div class="drawer-backdrop" (click)="onBackdropClick()"></div>

    <!-- PANEL -->
    <div class="drawer-panel">
        <ng-content></ng-content>
    </div>

</div>

